import axios from 'axios';

const list = (data) => axios.get('/pro/capacity/list', data);
const save = (data) => axios.post('/pro/capacity/save', data);
const del = (data) => axios.post('/pro/capacity/delete', data);


export default {
  list,
  save,
  del,

}


